import styled from 'styled-components'

/**
 * Sidebar sobre o mapa em tela cheia.
 *
 * `bottom` é obrigatório junto com `top`: é o que dá altura finita ao box e permite que
 * o `flex: 1` do SidebarContent role. Sem ele o container crescia com o conteúdo e os
 * itens ficavam escondidos abaixo da tela quando havia muitas análises adicionadas.
 */
export const SidebarContainerFullscreen = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  bottom: 15px;
  width: 380px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  z-index: 5;
  overflow: hidden;
`

export const SidebarTopBar = styled.div`
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`

export const SidebarContent = styled.div`
  display: flex;
  flex: 1; /* Make it expand */
  flex-direction: column;
  gap: 5px;
  /* Sem isto o item flex não encolhe abaixo do conteúdo e o overflow-y nunca ativa. */
  min-height: 0;
  overflow-y: auto;
  padding: 15px;
  position: relative;
`

export const SidebarFooter = styled.div`
  width: 100%;
  padding: 15px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  flex-shrink: 0;
`
